export const CONTENT_CARD_TEST_IDS = {
    BADGE: 'content-card-badge',
};
